export default "__VITE_ASSET__BtdframW__"